document.addEventListener('giftship.loaded', function () {
  const currentPage = window.GSSDK.page.get();
  console.log("Giftship loaded - current page is: ", currentPage);
  if(!window.location.href.includes('2331')) return;
  showBoxBuilderLoader();
  waitForProductsStep(function () {
    removeBoxBuilderLoader();
    injectYoIndulgeContent();
  });
});

// ── Loading indicator injected into #boxBuilderRoot ───────────────────────────

function showBoxBuilderLoader() {
  const root = document.querySelector('#boxBuilderRoot');
  if (!root || document.getElementById('yo-box-loader')) return;

  const loaderStyle = document.createElement('style');
  loaderStyle.id = 'yo-box-loader-style';
  loaderStyle.textContent = `
    #boxBuilderRoot {
      padding-bottom: 0;
    }
    #yo-box-loader {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 64px 24px;
      gap: 20px;
    }
    #yo-box-loader .yo-spinner {
      width: 36px;
      height: 36px;
      border: 3px solid #e8d8ce;
      border-top-color: #AF6E4E;
      border-radius: 50%;
      animation: yo-spin 0.75s linear infinite;
    }
    #yo-box-loader .yo-loader-text {
      font-family: 'Google Sans', sans-serif;
      font-size: 14px;
      color: #AF6E4E;
      letter-spacing: 0.03em;
    }
    @keyframes yo-spin {
      to { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(loaderStyle);

  const loader = document.createElement('div');
  loader.id = 'yo-box-loader';
  loader.innerHTML = `
    <div class="yo-spinner"></div>
    <span class="yo-loader-text">Loading products\u2026</span>
  `;
  root.appendChild(loader);
}

function removeBoxBuilderLoader() {
  const loader = document.getElementById('yo-box-loader');
  const loaderStyle = document.getElementById('yo-box-loader-style');
  if (loader) loader.remove();
  if (loaderStyle) loaderStyle.remove();
}

// ── Wait for .gs__banner-image-wrapper via MutationObserver (15 s timeout) ───

function waitForProductsStep(callback) {
  if (document.querySelector('#gsBuilderNav')) {
    callback();
    return;
  }

  const TIMEOUT_MS = 15000;
  let resolved = false;

  const observer = new MutationObserver(function () {
    if (document.querySelector('#gsBuilderNav')) {
      resolved = true;
      observer.disconnect();
      callback();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(function () {
    if (!resolved) {
      observer.disconnect();
      removeBoxBuilderLoader();
      console.warn('[Yo Indulge] .gs__banner-image-wrapper not found within timeout — skipping content injection.');
    }
  }, TIMEOUT_MS);
}

// ── Main content injection ────────────────────────────────────────────────────

function injectYoIndulgeContent() {
  const giftshipRoot = document.querySelector('#boxBuilderRoot');
  const mount = giftshipRoot || document.querySelector('main') || document.body;

  if (document.getElementById('yo-indulge-corporate-sections')) return;

  const style = document.createElement('style');
  style.textContent = `
    #yo-indulge-corporate-sections {
      --brand: #AF6E4E;
      --brand-dark: #8a5238;
      --brand-light: #f5ede6;
      --brand-lighter: #fdf8f5;
      --text-primary: #1a1a1a;
      --text-secondary: #4a4a4a;
      --text-muted: #888;
      --border: #e8d8ce;
      font-family: 'Google Sans', 'Product Sans', sans-serif;
    }

    .yo-section {
      padding: 64px 24px;
      max-width: 860px;
      margin: 0 auto;
    }

    /* ── HERO OVERLAY on existing Giftship banner ── */
   .gs__banner-image-wrapper img.gs__banner-image {
    width: 100% !important;
height: auto !important;
    max-width: 100% !important;
    max-height: none !important;

    min-width: unset !important;
    min-height: unset !important;

object-fit: cover !important;
transform: scale(1) !important;
object-position: center top !important;
background: #000 !important;
}

/* MOBILE BANNER IMAGE */
@media (max-width: 768px) {
  .gs__banner-image-wrapper img.gs__banner-image {
    content: url("https://cdn.shopify.com/s/files/1/0527/4553/5648/files/Mobile_-_Cor_gifting.png?v=1779340628");
    object-fit: cover !important;
    width: 100% !important;
    height: auto !important;
  }
}

    #yo-hero-overlay {
      position: absolute;
      inset: 0;
        z-index: 1 !important;
      background: linear-gradient(
        to top,
        rgba(0,0,0,0.70) 0%,
        rgba(0,0,0,0.35) 45%,
        rgba(0,0,0,0.05) 100%
      );
      pointer-events: none;
    }
      .gs__banner-image-wrapper {
  position: relative !important;
    height: auto!important;

}

    #yo-hero-content {
  width: 100%;
  box-sizing: border-box;
  pointer-events: auto;
  display: flex !important;
  flex-direction: column !important;
  color: #fff !important;
}

    #yo-hero-content .yo-hero-eyebrow {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.16em;
      text-transform: uppercase;
      color: rgba(255,255,255,0.75);
      margin: 0 0 14px;
      font-family: 'Google Sans', 'Product Sans', sans-serif;
    }
    #yo-hero-content .yo-hero-heading {
      font-family: 'Google Sans Display', 'Google Sans', sans-serif;
      font-size: clamp(26px, 4.5vw, 50px);
      font-weight: 700;
      color: #fff;
      line-height: 1.15;
      margin: 0 0 18px;
      max-width: 660px;
      text-shadow: 0 2px 20px rgba(0,0,0,0.3);
    }
    #yo-hero-content .yo-hero-heading em {
      font-style: normal;
      color: #f5c99a;
    }
    #yo-hero-content .yo-hero-sub {
      font-size: clamp(13px, 1.8vw, 16px);
      color: rgba(255,255,255,0.88);
      line-height: 1.75;
      max-width: 580px;
      margin: 0 0 28px;
      font-family: 'Google Sans', 'Product Sans', sans-serif;
    }
    .yo-hero-cta-row {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      align-items: center;
    }
    .yo-hero-btn-primary {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #AF6E4E;
      color: #fff;
      font-family: 'Google Sans', 'Product Sans', sans-serif;
      font-size: 14px;
      font-weight: 700;
      padding: 14px 26px;
      border-radius: 50px;
      border: none;
      cursor: pointer;
      text-decoration: none;
      letter-spacing: 0.01em;
      transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
    }
    .yo-hero-btn-primary:hover {
      background: #8a5238;
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(0,0,0,0.25);
    }
    .yo-hero-btn-primary svg {
      width: 14px; height: 14px;
      stroke: #fff; stroke-width: 2.5; fill: none;
      transition: transform 0.2s;
    }
    .yo-hero-btn-primary:hover svg { transform: translateX(3px); }
    .yo-hero-btn-ghost {
      display: inline-flex;
      align-items: center;
      background: rgba(255,255,255,0.12);
      backdrop-filter: blur(6px);
      color: #fff;
      font-family: 'Google Sans', 'Product Sans', sans-serif;
      font-size: 14px;
      font-weight: 600;
      padding: 13px 24px;
      border-radius: 50px;
      border: 1.5px solid rgba(255,255,255,0.40);
      cursor: pointer;
      text-decoration: none;
      transition: background 0.2s, border-color 0.2s;
    }
    .yo-hero-btn-ghost:hover {
      background: rgba(255,255,255,0.22);
      border-color: rgba(255,255,255,0.65);
    }

    /* ── HOW IT WORKS ── */

   #yo-how-heading{
  /* margin-bottom */
}

#yo-how {
  background: #fff;
  padding: 20px;
  // margin-bottom: 20px;
}

#yo-how .yo-how-inner {
  margin: 0 auto;
}

#yo-how .yo-how-eyebrow {
  font-size: 30px !important;
  font-weight: 700;
  font-family: 'Google Sans', 'Product Sans', sans-serif;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #AF6E4E;
  margin: 0 0 16px;
}

#yo-how .yo-how-headline {
  font-family: 'Google Sans Display', 'Google Sans', sans-serif;
  font-size: clamp(24px, 4vw, 36px);
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.2;
  margin: 0 0 24px;
}

#yo-how .yo-how-divider {
  width: 48px;
  height: 3px;
  background: #AF6E4E;
  border-radius: 2px;
  margin: 0 0 48px;
}

/* TABLET */
@media (max-width: 768px) {
  #yo-how .yo-how-eyebrow {
    font-size: 10px;
    letter-spacing: 0.12em;
  }

  #yo-how .yo-how-headline {
    font-size: 28px;
    line-height: 1.3;
  }
}

/* MOBILE */
@media (max-width: 480px) {
    #yo-how .yo-how-eyebrow {
    font-size: 26px !important;
  }


  #yo-how .yo-how-headline {
    font-size: 22px;
    line-height: 1.35;
  }
}

    .yo-steps-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 0;
      position: relative;
    }
    .yo-steps-grid::before {
      content: '';
      position: absolute;
      top: 25px;
      left: calc(12.5% + 20px);
      right: calc(12.5% + 20px);
      height: 2px;
      background: linear-gradient(to right, #e8d8ce, #AF6E4E 50%, #e8d8ce);
      z-index: 0;
    }
    .yo-step {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 0 16px;
      position: relative;
      z-index: 1;
    }
    .yo-step-number {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      background: #fff;
      border: 2px solid #AF6E4E;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Google Sans Display', 'Google Sans', sans-serif;
      font-size: 18px;
      font-weight: 700;
      color: #AF6E4E;
      margin: 0 auto 20px;
      flex-shrink: 0;
      box-shadow: 0 0 0 6px #fff;
      transition: background 0.25s, color 0.25s;
    }
    .yo-step:hover .yo-step-number {
      background: #AF6E4E;
      color: #fff;
    }
    .yo-step-title {
      font-size: 24px;
      font-weight: 700;
      color: #1a1a1a;
      margin: 0 0 10px;
      line-height: 1.3;
      font-family: 'Google Sans', 'Product Sans', sans-serif;
    }

    @media (max-width: 480px) {
  .yo-step-title {
    font-size: 17px !important;
  }
}
    .yo-step-desc {
      font-size: 1.6rem!important;
      color: #4a4a4a;
      line-height: 1.65;
      margin: 0;
      font-family: 'Google Sans', 'Product Sans', sans-serif;
    }

     @media (max-width: 480px) {
    .yo-step-desc {
    font-size: 14px !important;
  }
}
      .yo-step-extra {
  margin-top: 14px;
  font-size: 13px;
  font-weight: 700;
  color: #AF6E4E;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

    @media (max-width: 680px) {
      .yo-steps-grid {
        grid-template-columns: 1fr 1fr;
        gap: 40px 16px;
      }
      .yo-steps-grid::before { display: none; }

    }
    @media (max-width: 420px) {
      .yo-steps-grid { grid-template-columns: 1fr; gap: 32px; }
    }

/* TRUST BAR */
#yo-trust {
  background: #fff;
  padding: 32px 24px;
}

#yo-trust .yo-trust-inner {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  align-items: stretch;
}

.yo-trust-item {
  background: #f3ece6;
  border-radius: 6px;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex: 1 1 300px;
  min-width: 280px;
  min-height: 240px;
  transition: all 0.3s ease;
}

.yo-trust-img {
  width: 130px;
  height: 130px;
  object-fit: contain;
  display: block;
  margin-bottom: 16px;
  transition: transform 0.5s ease;
}

.yo-trust-item:hover .yo-trust-img {
  transform: scale(1.08);
}

.yo-trust-text {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.02em;
  color: #222;
  max-width: 240px;
  margin: 0 auto;
}

/* TABLET */
@media (max-width: 768px) {
  #yo-trust {
    padding: 32px 18px;
  }

  #yo-trust .yo-trust-inner {
    gap: 20px;
  }

  .yo-trust-item {
    min-width: calc(50% - 10px);
    min-height: 320px;
    padding: 36px 22px;
  }

  .yo-trust-img {
    width: 170px;
    height: 170px;
    margin-bottom: 22px;
  }

  .yo-trust-text {
    font-size: 19px;
  }
}

/* MOBILE */
@media (max-width: 480px) {
  #yo-trust {
    padding: 35px 16px;
  }

  #yo-trust .yo-trust-inner {
    flex-direction: column;
    gap: 18px;
  }

  .yo-trust-item {
    width: 100%;
    min-width: 100%;
    min-height: auto;
    padding: 32px 20px;
  }

  .yo-trust-img {
    width: 140px;
    height: 140px;
    margin-bottom: 18px;
  }

  .yo-trust-text {
    font-size: 18px;
    max-width: 100%;
  }
}


.yo-volume {
  width: 100%;
  padding-left: 25px;
  padding-right: 25px;
  box-sizing: border-box;
}

    /* WHY CHOOSE */
    #yo-why {
  background: var(--brand-lighter);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  padding: 72px 24px;
  text-align: center;
  height:550px;
}

#yo-why .yo-section {
  padding: 0;
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.yo-eyebrow {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--brand);
  margin: 0 0 16px;
  text-align: center;
}

.yo-headline {
  font-family: 'Google Sans Display', 'Google Sans', sans-serif;
  font-size: clamp(26px, 4vw, 38px);
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.2;
  margin: 0 0 24px;
  text-align: center;
  max-width: 700px;
}

.yo-divider {
  width: 48px;
  height: 3px;
  background: var(--brand);
  border-radius: 2px;
  margin: 0 auto 32px auto;
}

.yo-why-lead {
  font-size: 16px;
  color: var(--text-secondary);
  line-height: 1.7;
  max-width: 600px;
  margin: 0 auto 18px auto;
  font-style: italic;
  text-align: center;
}

.yo-why-body {
  font-size: 16px;
  color: var(--text-secondary);
  line-height: 1.75;
  max-width: 700px;
  text-align: center;
  margin: 0 auto;
}

.yo-why-body p {
  margin: 0 0 14px;
}

.yo-why-body p:last-child {
  margin-bottom: 0;
}

/* Responsive */
@media (max-width: 768px) {
  #yo-why {
    padding: 56px 18px;
  }

  .yo-eyebrow {
    font-size: 14px;
    letter-spacing: 0.12em;
  }

  .yo-headline {
    font-size: 30px;
    line-height: 1.3;
    margin-bottom: 20px;
    text-align:center;
    
  }

  .yo-why-lead,
  .yo-why-body {
    font-size: 15px;
    line-height: 1.7;
  }

  .yo-divider {
    margin-bottom: 24px;
  }
}

@media (max-width: 480px) {
  #yo-why {
    padding: 48px 16px;
  }

  .yo-headline {
    font-size: 26px;
  }

  .yo-why-lead,
  .yo-why-body {
    font-size: 14px;
  }
}
    /* FAQ */
    #yo-faq {
      background: #fff;
      padding: 20px 24px;
    }
    #yo-faq .yo-section { padding: 0; }
    .yo-faq-grid {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      gap: 0;
      border-top: 1px solid var(--border);
    }
    .yo-faq-item {
      border-bottom: 1px solid var(--border);
      overflow: hidden;
    }
    .yo-faq-btn {
      width: 100%;
      background: none;
      border: none;
      padding: 22px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      cursor: pointer;
      text-align: left;
      font-family: inherit;
    }
    .yo-faq-q {
      font-size: 16px;
      font-weight: 600;
      color: var(--text-primary);
      line-height: 1.4;
    }
    .yo-faq-icon {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1.5px solid var(--brand);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s, transform 0.3s;
    }
    .yo-faq-icon svg {
      width: 12px;
      height: 12px;
      stroke: var(--brand);
      stroke-width: 2.5;
      fill: none;
      transition: transform 0.3s;
    }
    .yo-faq-item.open .yo-faq-icon { background: var(--brand); }
    .yo-faq-item.open .yo-faq-icon svg { stroke: #fff; transform: rotate(45deg); }
    .yo-faq-answer {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.35s ease, padding 0.2s;
      padding: 0;
    }
    .yo-faq-item.open .yo-faq-answer { max-height: 300px; padding-bottom: 20px; }
    .yo-faq-answer p {
      margin: 0;
      font-size: 15px;
      color: var(--text-secondary);
      line-height: 1.7;
    }
    .yo-faq-answer a { color: var(--brand); text-decoration: underline; }

    /* FINAL CTA */
    #yo-cta {
      background: var(--brand);
      padding: 80px 24px;
      text-align: center;
    }

    #yo-cta-heading {
  text-align: center !important;
}
  #yo-cta .yo-headline {
  margin-left: auto !important;
  margin-right: auto !important;
}

    #yo-cta .yo-headline { color: #fff; margin-bottom: 12px; }
    .yo-cta-sub {
      font-size: 16px;
      color: rgba(255,255,255,0.85);
      line-height: 1.6;
      max-width: 520px;
      margin: 0 auto 36px;
      text-align:center
    }
    .yo-cta-btn {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      background: #fff;
      color: var(--brand);
      font-family: inherit;
      font-size: 15px;
      font-weight: 700;
      padding: 16px 32px;
      border: none;
      cursor: pointer;
      text-decoration: none;
      letter-spacing: 0.01em;
      transition: transform 0.2s, box-shadow 0.2s;
    }
    .yo-cta-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(0,0,0,0.15); }
    .yo-cta-btn svg {
      width: 16px;
      height: 16px;
      stroke: var(--brand);
      stroke-width: 2.5;
      fill: none;
      transition: transform 0.2s;
    }
    .yo-cta-btn:hover svg { transform: translateX(3px); }

    @media (max-width: 600px) {
      #yo-trust .yo-trust-inner { gap: 10px 20px; }
      .yo-trust-item { font-size: 13px; }
      .yo-faq-q { font-size: 15px; }
    }
  `;
  document.head.appendChild(style);

  const faqItems = [
    {
      q: 'Can I send gifts to multiple addresses in one order?',
      a: "Yes \u2014 that's exactly what this page is built for. Upload up to 500 addresses in a single order."
    },
    {
      q: 'Can I pay once for all gifts?',
      a: 'Yes. One payment covers products, shipping, and delivery to every recipient individually.'
    },
    {
      q: 'Can I add a custom message?',
      a: 'Absolutely. Use one message for everyone or customize messages per recipient.'
    },
    {
      q: 'What about GST invoices?',
      a: 'We generate a single GST invoice for the full order automatically. Add your GSTIN during checkout.'
    },
    {
      q: 'How long does corporate delivery take?',
      a: 'Most orders are delivered within 2\u20134 business days depending on pin code. Orders dispatch within 24 hours.'
    },
    {
      q: 'Can I see a sample first?',
      a: 'Yes. Email us at <a href="mailto:orders@yoIndulge.com">orders@yoIndulge.com</a> and we\u2019ll send a sample box to your office before you place a bulk order.'
    }
  ];

  const plusIcon  = '<svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  const arrowIcon = '<svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';

  const faqHTML = faqItems.map(function (item) {
    return '<div class="yo-faq-item">' +
      '<button class="yo-faq-btn" aria-expanded="false">' +
        '<span class="yo-faq-q">' + item.q + '</span>' +
        '<span class="yo-faq-icon" aria-hidden="true">' + plusIcon + '</span>' +
      '</button>' +
      '<div class="yo-faq-answer" role="region"><p>' + item.a + '</p></div>' +
    '</div>';
  }).join('');

  // ── Steps for How It Works ────────────────────────────────────────────────
  const steps = [
    { number: '1', title: 'Choose Your Gift',    desc: 'Pick Yo Majun, Yo Brownies, or our mixed bestseller box.' },
    { number: '2', title: 'Upload Addresses',    desc: 'Upload CSV, Excel, or paste recipient details directly into our form.' },
    { number: '3', title: 'Add Your Message',    desc: 'Choose one message for everyone or personalize each gift individually.' },
    { number: '4', title: 'Pay Once',            desc: 'One checkout. One invoice. We handle packing and individual deliveries everywhere.' }
  ];

  const stepsHTML = steps.map(function (s) {
    return '<div class="yo-step">' +
      '<div class="yo-step-number">' + s.number + '</div>' +
      '<div class="yo-step-title">' + s.title + '</div>' +
      '<p class="yo-step-desc">' + s.desc + '</p>' +
    '</div>';
  }).join('');

  // ── Inject custom banner + hero content before #gsBuilderNav ─────────────
  var gsBuilderNav = document.querySelector('#gsBuilderNav');

  if (gsBuilderNav && !document.getElementById('yo-hero-content')) {

    // 1. Remove any pre-existing third-party .gs__banner-image-wrapper
    document.querySelectorAll('.gs__banner-image-wrapper:not([data-yo-banner])').forEach(function (el) {
      el.remove();
      console.log('[Yo Indulge] Removed pre-existing third-party .gs__banner-image-wrapper');
    });

    // 2. Create and insert our custom banner (marked so we never remove it)
    // var customBanner = document.createElement('div');
    // customBanner.className = 'gs__banner-image-wrapper';
    // customBanner.setAttribute('data-yo-banner', 'true');
    // customBanner.innerHTML =
    //   // '<img alt="Corporate Gifting Made Deliciously Easy." class="gs__banner-image" ' +
    //   // 'src="https://cdn.shopify.com/s/files/1/0527/4553/5648/files/Frame_1_1.png?v=1779272671">';

    // gsBuilderNav.parentNode.insertBefore(customBanner, gsBuilderNav);
    // console.log('[Yo Indulge] Custom banner injected');

    // 3. Create and insert How It Works hero content (immediately after banner)
    var heroContent = document.createElement('div');
    heroContent.id = 'yo-hero-content';
    heroContent.innerHTML =
      '<section id="yo-how" role="region" aria-labelledby="yo-how-heading">' +
        '<div class="yo-how-inner">' +
          '<p class="yo-how-eyebrow" style="color:black !important;">How It Works</p>' +
          '<h2 class="yo-how-headline" id="yo-how-heading" style="margin-bottom:20px !important; margin-top:5px !important; font-size:18px !important;">Send gifts across India in four simple steps.</h2>' +
          '<div class="yo-how-divider"></div>' +
          '<div class="yo-steps-grid">' + stepsHTML + '</div>' +
        '</div>' +
      '</section>';

    // Insert heroContent right after the custom banner (before gsBuilderNav)
    gsBuilderNav.parentNode.insertBefore(heroContent, gsBuilderNav);
    console.log('[Yo Indulge] Hero content injected after custom banner');

    // 4. Watch for any future third-party .gs__banner-image-wrapper and remove them
    var bannerGuardObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return; // element nodes only

          // Check if the added node itself is an unmarked banner
          if (
            node.classList &&
            node.classList.contains('gs__banner-image-wrapper') &&
            node.getAttribute('data-yo-banner') !== 'true'
          ) {
            node.remove();
            console.log('[Yo Indulge] Removed third-party .gs__banner-image-wrapper added after init');
            return;
          }

          // Also sweep any unmarked banners nested inside the added node
          if (node.querySelectorAll) {
            node.querySelectorAll('.gs__banner-image-wrapper:not([data-yo-banner])').forEach(function (el) {
              el.remove();
              console.log('[Yo Indulge] Removed nested third-party .gs__banner-image-wrapper');
            });
          }
        });
      });
    });

    bannerGuardObserver.observe(document.body, { childList: true, subtree: true });
    console.log('[Yo Indulge] Banner guard observer active');
  }

  // ── Build the remaining sections wrapper ─────────────────────────────────
  var wrapper = document.createElement('div');
  wrapper.id = 'yo-indulge-corporate-sections';
  wrapper.innerHTML =

    // TRUST BAR
    '<div id="yo-trust" role="region" aria-label="Trust signals">' +
    // '<div style="text-align:center; margin:0 0 42px 0;">' +
    // '<a href="https://yobrownies.myshopify.com/a/gs/builder/2344" class="yo-cta-btn" style="display:inline-flex !important; align-items:center !important; justify-content:center !important; gap:10px !important; background:#AF6E4E !important; color:#ffffff !important; border:none !important; padding:16px 32px !important; text-decoration:none !important; font-weight:700 !important;">' +
    //   'Build Your Own Custom Box ' +
    //   '<span style="display:flex !important; align-items:center !important; color:#fff !important;">' +
    //     arrowIcon.replace('<svg', '<svg style="stroke:#fff !important;"') +
    //   '</span>' +
    // '</a>' +
    // '</div>' +
    '<div class="yo-trust-inner">' +
      '<div class="yo-trust-item">' +
        '<img src="https://cdn.shopify.com/s/files/1/0527/4553/5648/files/corporate-gifting.png?v=1778856872" alt="Secure Payments" class="yo-trust-img">' +
        '<span class="yo-trust-text">Secure Payments</span>' +
      '</div>' +
      '<div class="yo-trust-item">' +
        '<img src="https://cdn.shopify.com/s/files/1/0527/4553/5648/files/on-time-delivery.png?v=1778856872" alt="On-Time Delivery" class="yo-trust-img">' +
        '<span class="yo-trust-text">On-Time Delivery</span>' +
      '</div>' +
      '<div class="yo-trust-item">' +
        '<img src="https://cdn.shopify.com/s/files/1/0527/4553/5648/files/no-preservatives.png?v=1778856872" alt="100% Quality Guarantee" class="yo-trust-img">' +
        '<span class="yo-trust-text">100% Quality Guarantee</span>' +
      '</div>' +
    '</div>' +
    '</div>' +

    // WHY CHOOSE
    '<div id="yo-why" role="region" aria-labelledby="yo-why-heading" style="margin-bottom:6px;">' +
      '<div class="yo-section">' +
        '<p class="yo-eyebrow">Why companies choose us</p>' +
        '<h2 class="yo-headline" id="yo-why-heading">Gifting that actually gets\u00a0remembered.</h2>' +
        '<div class="yo-divider"></div>' +
        '<p class="yo-why-lead">Most corporate gifts get opened, smiled at politely, and forgotten.</p>' +
        '<div class="yo-why-body">' +
          '<p>Yo Indulge are different Freshly handmade in Mumbai, individually packed, beautifully designed, and delivered directly to each recipient \u2014 without your HR or admin team managing courier chaos manually.</p>' +
          '<p>From startup teams to enterprise clients, we help brands gift something people genuinely want to eat.</p>' +
        '</div>' +
      '</div>' +
      '<div style="text-align:center; margin:28px 0 60px 0;">' +
        '<a href="https://yobrownies.myshopify.com/a/gs/builder/2344" class="yo-cta-btn" style="display:inline-flex !important; align-items:center !important; justify-content:center !important; gap:10px !important; background:#AF6E4E !important; color:#ffffff !important; border:none !important; padding:16px 32px !important; text-decoration:none !important; font-weight:700 !important;">' +
          'Build Your Own Custom Box ' +
          '<span style="display:flex !important; align-items:center !important; color:#fff !important;">' +
            arrowIcon.replace('<svg', '<svg style="stroke:#fff !important;"') +
          '</span>' +
        '</a>' +
      '</div>' +
    '</div>' +

    // FAQ
    '<div id="yo-faq" role="region" aria-labelledby="yo-faq-heading">' +
      '<div class="yo-section">' +
        '<p class="yo-eyebrow">FAQ\'S</p>' +
        '<h2 class="yo-headline" id="yo-faq-heading">Frequently Asked Questions</h2>' +
        '<div class="yo-divider"></div>' +
        '<div class="yo-faq-grid">' + faqHTML + '</div>' +
      '</div>' +
    '</div>' +

    // FINAL CTA
    '<div id="yo-cta" role="region" aria-labelledby="yo-cta-heading">' +
      '<h2 class="yo-headline" id="yo-cta-heading" style="text-align:center !important; font-size:clamp(22px,5vw,38px) !important;">One order. Hundreds of smiles.</h2>' +
      '<p class="yo-cta-sub">Premium dessert gifting for teams, clients, events, and celebrations \u2014 delivered across India.</p>' +
      '<a href="#boxBuilderRoot" class="yo-cta-btn">Start Corporate Gifting ' + arrowIcon + '</a>' +
    '</div>';

  // ── Insert the sections wrapper into #MainContent (after box builder nav) ─
  var boxBuilderRoot = document.querySelector('#MainContent');
  var bannerWrapper_local = document.querySelector('.gs__banner-image-wrapper[data-yo-banner]');

  if (boxBuilderRoot) {
    boxBuilderRoot.appendChild(wrapper);
    console.log('[Yo Indulge] Sections wrapper appended to #MainContent');
  } else if (bannerWrapper_local && bannerWrapper_local.nextSibling) {
    bannerWrapper_local.parentNode.insertBefore(wrapper, bannerWrapper_local.nextSibling);
    console.log('[Yo Indulge] Sections wrapper inserted after custom banner');
  } else {
    document.body.appendChild(wrapper);
    console.log('[Yo Indulge] Sections wrapper appended to body');
  }

  // FAQ accordion
  wrapper.querySelectorAll('.yo-faq-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.yo-faq-item');
      var isOpen = item.classList.contains('open');
      wrapper.querySelectorAll('.yo-faq-item.open').forEach(function (el) {
        el.classList.remove('open');
        el.querySelector('.yo-faq-btn').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });
}